import { ArrowUp } from "lucide-react";
import { useConfig } from "../../hooks/useConfig";
import { useState, useEffect } from "react";
import "./ScrollToTopButton.css";

export const ScrollToTopButton = () => {
  const { config } = useConfig();
  const [visible, setVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  // Visibility & Scroll Progress
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      setScrollProgress(docHeight > 0 ? (scrollY / docHeight) * 100 : 0);
      setVisible(scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!config?.ui?.scrollToTopButton || !visible) return null;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className="scroll-to-top-button"
    >
      <ArrowUp size={24} className="arrow-icon" />
      <div
        className="scroll-progress"
        style={{ width: `${scrollProgress}%` }}
      />
    </button>
  );
};

export default ScrollToTopButton;